<app-loader *ngIf="show"></app-loader>

<div fxLayout="column" style="min-height: 80vh;">
  <!-- Header Section Starts -->
  <span fxLayout="row" class="div-header">
    <span fxFlex fxLayoutAlign="start start" fxLayout="row">
      <span class="header medium" ngStyle.xs="font-size:14px">{{proxyRequestMember.length}}
        {{'crew_member' | transloco}}</span>
    </span>
    <span class="close regular" fxLayout="row" fxLayoutAlign="end end" ngStyle.xs="font-size:14px">
      <a (click)="close()">{{'close'|transloco}}</a></span>
  </span>
  <div>

    <cdk-virtual-scroll-viewport [class]="cssclass" itemSize="50">

      <div class="div-container">
        <span fxLayout="column" *cdkVirtualFor="let user of proxyRequestMember; let i = index">
          <span fxLayout="column" fxLayoutGap="0px">
            <span fxLayout="row" class="list medium" fxLayoutGap="20px">
              <span *ngIf="!showDelete && (showRequestQR ||showApproveQR )" style="cursor: pointer;"
                (click)="getQRCode(user,'view');"> <img alt="qrcode" class="img-status" height="40" width="40"
                    src="assets/icons/qrCodeicon.svg" />
            </span>
            <div fxLayout="column" fxFlex="50" fxLayoutGap="5px">
                <div fxLayout="column" fxLayoutAlign="center">
                    <span class="name medium">{{user.name}}</span>
                </div>
                <div fxLayout="column" fxLayoutAlign="center">
                    <span class="designation regular">{{user.jobTitle}}</span>
                </div>
            </div>
            <div *ngIf="showDelete" fxFlex fxLayoutAlign="end center" fxLayoutGap="5px">
                <span id="cross" class="medium" fxLayoutAlign="end center"
                    style="width: 10px; height: 30px;cursor: pointer;"
                    (click)="delete(user.alias, user.phone)">X</span>
            </div>
            <div *ngIf="!showDelete && (showRequestQR ||showApproveQR )" fxFlex fxLayoutAlign="end center"
                fxLayoutGap="5px">
                <span id="cross" class="medium"  fxLayoutAlign="end center"
                    style="width: 10px; height: 30px;cursor: pointer;font-size: 12px; color: #0014dc;"
                    (click)="getQRCode(user,'download');">Download</span>
            </div>

            </span>
            <mat-divider></mat-divider>
          </span>
        </span>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
